
import { Page, Tabs, Badge, Layout, Link, FooterHelp, Icon, InlineStack, Text, BlockStack, Card, Divider, Bleed } from '@shopify/polaris';
import { DI, DIProps } from '../../../../Core';
import { CircleInformationMajor } from '@shopify/polaris-icons';
import React, { useState, useEffect } from 'react';
import { dataGridSkeleton } from '../../Settings/Template/Components/skeleton/Skeleton'
import { useTranslation } from 'react-i18next';

interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: () => void;
    amazon_order_id: string;
}

function ViewOrder(props: Props) {
    const { t } = useTranslation();
    const defaultTabs = [
        {
            id: 'amazon',
            content: t('Amazon'),
            accessibilityLabel: 'Amazon',
        },
    ];
    const [data, setData] = useState<any>({});
    const [tabs, setTabs] = useState<any>(defaultTabs);
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [extraInfo, setExtraInfo] = useState<any>({});

    const fillExtraInfo = (data: any) => {
        if (data?.attributes) {
            let extraAttributes = [...data?.attributes];
            let dummyObj: any = {};
            extraAttributes.map((obj: any) => {
                dummyObj[obj['key']] = obj['value']
            })
            setExtraInfo({ ...dummyObj });
        }
    }

    const getOrderInfo = async () => {

        let response = await props.di.GET('connector/order/get',
            {
                cif_order_id: props?.match?.['o_id'],
                user_id: props.di.user_id, object_type: 'source_order',
                marketplace_shop_id: props?.redux?.current?.target?.['_id'],
                marketplace: "amazon",
            });
        if (response.success) {
            setData({ ...response?.data })
            fillExtraInfo({ ...response?.data });
            let tempTabs = [...tabs,
            {
                id: 'shopify',
                content: 'Shopify',
                accessibilityLabel: 'Shopify',
            },];
            setTabs([...tempTabs])
        }
        else {
            props.error(t(response.message))
        }
    }
    useEffect(() => {
        getOrderInfo();
    }, [])

    const handleTabChange = (tab: number) => {
        setSelectedTab(tab)
    }

    const getAmazonExtraInfo = () => {
        let jsx: any = "";
        if (Object.keys(extraInfo).length > 0) {
            jsx = Object.keys(extraInfo).map((key: string) => {
                return (
                    <InlineStack gap="400" align="space-between" key={key}>
                        <Text as='p' fontWeight="semibold">{key}</Text>
                        <Text as='p'>{extraInfo?.[key]}</Text>
                    </InlineStack>
                );
            })
        }
        return jsx;
    }
    if (Object.keys(data).length > 0) {
        return (
            <Page
                backAction={{ content: t('View Order'), onAction: () => { props.history(-1); } }}
                title={data['source_marketplace_order_id']}
                subtitle={t('View your order')}
                titleMetadata={<Badge tone="attention">{data['marketplace_status']}</Badge>}
            >
                <Tabs tabs={tabs} selected={selectedTab} onSelect={handleTabChange}>
                    {selectedTab == 0 &&
                        <div className='custom-detailing'>
                            <Layout>
                                <Layout.Section>
                                    <BlockStack gap="400">
                                        {<Card roundedAbove='sm'>
                                            <BlockStack gap="400">
                                                <Text as='h2' variant='headingMd'>{data['marketplace_status']} ({data?.['items']?.[0]?.['qty']})</Text>
                                                <BlockStack gap="100">
                                                    <InlineStack gap="400" align="space-between">
                                                        <InlineStack gap="400" align="start">
                                                            <CustomBadgeWithCount count={data?.['items']?.[0]?.['qty']}/>
                                                            <BlockStack gap="100">
                                                                <div style={{ maxWidth: '300px', wordBreak: 'break-all' }}>
                                                                    <Text as='p' fontWeight="semibold">{data?.['items']?.[0]?.['title']}</Text>
                                                                </div>
                                                                <Text as='p' tone="subdued">{t("SKU:")} {data?.['items']?.[0]?.['sku']}</Text>
                                                            </BlockStack>
                                                        </InlineStack>
                                                        <div>{data?.marketplace_currency} {data?.total?.marketplace_price}</div>
                                                    </InlineStack>
                                                    {
                                                        <InlineStack gap="400" align="space-between">
                                                            <Text as='p' fontWeight="semibold">{t("Total")}</Text>
                                                            <Text as='p' fontWeight="semibold">{data?.marketplace_currency} {data?.total?.marketplace_price}</Text>
                                                        </InlineStack>
                                                    }
                                                </BlockStack>
                                            </BlockStack>
                                        </Card>
                                        }
                                        {Object.keys(extraInfo).length > 0 &&
                                            <Card roundedAbove='sm'>
                                                {getAmazonExtraInfo()}
                                            </Card>
                                        }
                                    </BlockStack>
                                </Layout.Section>
                                <Layout.Section variant="oneThird">
                                    <BlockStack gap="400">
                                        <Card roundedAbove='sm'>
                                            <BlockStack gap="400">
                                                <Text as='h2' variant='headingMd'>{t("Customer Information")}</Text>
                                                <BlockStack gap="400">
                                                    {
                                                        <BlockStack gap="200">
                                                            <Text as='h2' variant='headingMd'>{t("Customer")}</Text>
                                                            <BlockStack gap="100">
                                                                <div style={{ overflowWrap: 'break-word' }}>
                                                                    <Text as='p'>{data?.customer?.name}</Text>
                                                                </div>
                                                                <div style={{ overflowWrap: 'break-word' }}>
                                                                    <Text as='p'>{data?.customer?.email}</Text>
                                                                </div>
                                                            </BlockStack>
                                                        </BlockStack>
                                                    }
                                                    <Bleed marginInline="500">
                                                        <Divider />
                                                    </Bleed>
                                                    {
                                                        <>
                                                            <BlockStack gap="200">
                                                                <Text as='h2' variant='headingMd'>{t("SHIPPING ADDRESS")}</Text>
                                                                <div>
                                                                    <div>{data?.shipping_address?.[0]?.first_name}</div>
                                                                    <div>{data?.shipping_address?.[0]?.last_name}</div>
                                                                    <div>{data?.shipping_address?.[0]?.address}</div>
                                                                    {data?.shipping_address?.[0]?.address1 && <div>{data?.shipping_address?.[0]?.address1}</div>}
                                                                    {data?.shipping_address?.[0]?.address2 && <div>{data?.shipping_address?.[0]?.address2}</div>}
                                                                    <div>{data?.shipping_address?.[0]?.zip} {data?.shipping_address?.[0]?.city}</div>
                                                                    {data?.billing_address?.countryCode && <div>{data?.billing_address?.countryCode}</div>}
                                                                    {data?.billing_address?.phone && <div>{data?.billing_address?.phone}</div>}
                                                                </div>
                                                            </BlockStack>
                                                        </>
                                                    }
                                                    <Bleed marginInline="500">
                                                        <Divider borderColor='border' />
                                                    </Bleed>
                                                    {data?.billing_address?.same_as_shipping ? <>
                                                        <BlockStack gap="200">
                                                            <Text as='h2' variant='headingMd'>{t("BILLING ADDRESS")}</Text>
                                                            <Text as='p' tone="subdued">{t("Same as shipping address")}</Text>
                                                        </BlockStack>
                                                    </> :
                                                        <>
                                                            <BlockStack gap="200">
                                                                <Text as='h2' variant='headingMd'>{t("BILLING ADDRESS")}</Text>
                                                                <div>
                                                                    {data?.billing_address?.first_name && <div>{data?.billing_address?.first_name}</div>}
                                                                    {data?.billing_address?.last_name && <div>{data?.billing_address?.last_name}</div>}
                                                                    {data?.billing_address?.address && <div>{data?.billing_address?.address}</div>}
                                                                    {data?.billing_address?.address1 && <div>{data?.billing_address?.address1}</div>}
                                                                    {data?.billing_address?.address2 && <div>{data?.billing_address?.address2}</div>}
                                                                    <div>{data?.billing_address?.zip && data?.billing_address?.zip} {data?.billing_address?.city && data?.billing_address?.city}</div>
                                                                    {data?.billing_address?.countryCode && <div>{data?.billing_address?.countryCode}</div>}
                                                                    {data?.billing_address?.phone && <div>{data?.billing_address?.phone}</div>}
                                                                </div>
                                                            </BlockStack>
                                                        </>
                                                    }
                                                </BlockStack>
                                            </BlockStack>
                                        </Card>
                                    </BlockStack>
                                </Layout.Section>
                            </Layout>
                        </div>}
                    {
                        selectedTab === 1 &&
                        <div className='custom-detailing'>
                            <Layout>
                                <Layout.Section>
                                    <BlockStack gap="400">
                                        <Card roundedAbove='sm'>
                                            <BlockStack gap="400">
                                                <Text as='h2' variant='headingMd'>{data?.['targets']?.[0]?.status} ({data?.['items']?.[0]?.['qty']})</Text>
                                                <BlockStack gap="100">
                                                    <InlineStack gap="400" align="space-between">
                                                        <InlineStack gap="400" align="start">
                                                            <CustomBadgeWithCount count={data?.['items']?.[0]?.['qty']}/>
                                                            <BlockStack gap="100">
                                                                <div style={{ maxWidth: '300px', wordBreak: 'break-all' }}>
                                                                    <Text as='p' fontWeight="semibold">{data?.['targets']?.[0]?.title}</Text>
                                                                </div>
                                                                <Text as='p' tone="subdued">{t("SKU:")} {data?.['items']?.[0]?.['sku']}</Text>
                                                            </BlockStack>
                                                        </InlineStack>
                                                        <div>{data?.marketplace_currency} {data?.total?.price}</div>
                                                    </InlineStack>
                                                    <InlineStack gap="400" align="space-between">
                                                        <Text as='p' fontWeight="semibold">{t("Total")}</Text>
                                                        <Text as='p' fontWeight="semibold">{data?.marketplace_currency} {data?.total?.price}</Text>
                                                    </InlineStack>
                                                </BlockStack>
                                            </BlockStack>
                                        </Card>
                                    </BlockStack>
                                </Layout.Section>
                                <Layout.Section variant="oneThird">
                                    <BlockStack gap="400">
                                        <Card roundedAbove='sm'>
                                            <BlockStack gap="400">
                                                <Text as='h2' variant='headingMd'> {t("Customer Information")}</Text>
                                                <BlockStack gap="400">
                                                    {

                                                        <>
                                                            <BlockStack gap="200">
                                                                <Text as='h2' variant='headingMd'>{t("Customer")}</Text>
                                                                <BlockStack gap="100">
                                                                    <div style={{ overflowWrap: 'break-word' }}>
                                                                        <Text as='p'>{data?.customer?.name}</Text>
                                                                    </div>
                                                                    <div style={{ overflowWrap: 'break-word' }}>
                                                                        <Text as='p'>{data?.customer?.email}</Text>
                                                                    </div>
                                                                </BlockStack>
                                                            </BlockStack>
                                                        </>
                                                    }
                                                    <Bleed marginInline="500">
                                                        <Divider />
                                                    </Bleed>
                                                    {
                                                        <>
                                                            <BlockStack gap="200">
                                                                <Text as='h2' variant='headingMd'>{t("SHIPPING ADDRESS")}</Text>
                                                                <div>
                                                                    <div>{data?.shipping_address?.[0]?.first_name}</div>
                                                                    <div>{data?.shipping_address?.[0]?.last_name}</div>
                                                                    <div>{data?.shipping_address?.[0]?.address}</div>
                                                                    {data?.shipping_address?.[0]?.address1 && <div>{data?.shipping_address?.[0]?.address1}</div>}
                                                                    {data?.shipping_address?.[0]?.address2 && <div>{data?.shipping_address?.[0]?.address2}</div>}
                                                                    <div>{data?.shipping_address?.[0]?.zip} {data?.shipping_address?.[0]?.city}</div>
                                                                    {data?.billing_address?.countryCode && <div>{data?.billing_address?.countryCode}</div>}
                                                                    {data?.billing_address?.phone && <div>{data?.billing_address?.phone}</div>}
                                                                </div>
                                                            </BlockStack>
                                                        </>
                                                    }
                                                    <Bleed marginInline="500">
                                                        <Divider />
                                                    </Bleed>
                                                    {data?.billing_address?.same_as_shipping ? <>
                                                        <BlockStack gap="200">
                                                            <Text as='h2' variant='headingMd'>{t("BILLING ADDRESS")}</Text>
                                                            <Text as='h2' tone="subdued">{t("Same as shipping address")}</Text>
                                                        </BlockStack>
                                                    </> :
                                                        <>
                                                            <BlockStack gap="200">
                                                                <Text as='h2' variant='headingMd'>{t("BILLING ADDRESS")}</Text>
                                                                <div>
                                                                    {data?.billing_address?.first_name && <div>{data?.billing_address?.first_name}</div>}
                                                                    {data?.billing_address?.last_name && <div>{data?.billing_address?.last_name}</div>}
                                                                    {data?.billing_address?.address && <div>{data?.billing_address?.address}</div>}
                                                                    {data?.billing_address?.address1 && <div>{data?.billing_address?.address1}</div>}
                                                                    {data?.billing_address?.address2 && <div>{data?.billing_address?.address2}</div>}
                                                                    <div>{data?.billing_address?.zip && data?.billing_address?.zip} {data?.billing_address?.city && data?.billing_address?.city}</div>
                                                                    {data?.billing_address?.countryCode && <div>{data?.billing_address?.countryCode}</div>}
                                                                    {data?.billing_address?.phone && <div>{data?.billing_address?.phone}</div>}
                                                                </div>
                                                            </BlockStack>
                                                        </>
                                                    }
                                                </BlockStack>
                                            </BlockStack>
                                        </Card>
                                    </BlockStack>
                                </Layout.Section>
                            </Layout>
                        </div>
                    }
                </Tabs>
                <FooterHelp>
                    <InlineStack align="center" gap="100">
                        <div>
                            <Icon
                                source={CircleInformationMajor}
                                tone="info"
                            />
                        </div>
                        {t("Learn more about")}
                        <Link target='_blank' url="https://support.cedcommerce.com/portal/en/kb/articles/overview-26-3-2024#:~:text=seller%20(your)%20credibility.-,Orders,-This%20section%20centralizes">
                            {t("CedCommerce Amazon Channel")},
                        </Link><Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf'>
                            {t("Terms & Conditions")}
                        </Link>{t("and")}<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf'>
                            {t("Data Privacy Rights.")}
                        </Link> {t("Need Help?")}<Link target='_blank'
                            url={`https://admin.shopify.com/apps${process.env.REACT_APP_SHOPIFY_APP_BASE}/panel/user/support`}>
                            {t("Get Support")}
                        </Link>{t("or")}<Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales" >
                            {t("Book a Call")}
                        </Link>
                    </InlineStack>
                </FooterHelp>
            </Page>
        );
    }
    else {
        return (
            <Page
                backAction={{ content: 'View Order', onAction: () => { props.history(-1); } }}
                title={data['source_marketplace_order_id']}
                subtitle={'View your order'}
                titleMetadata={<Badge tone="attention">{data['marketplace_status']}</Badge>}
            >
                {dataGridSkeleton()}
                <FooterHelp>
                    <InlineStack align="center" gap="100">
                        <div>
                            <Icon
                                source={CircleInformationMajor}
                                tone="info"
                            />
                        </div>{t("Learn more about")}<Link target='_blank' url="https://support.cedcommerce.com/portal/en/kb/articles/overview-26-3-2024">
                            {t("CedCommerce Amazon Channel")},
                        </Link><Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf'>
                            {t("Terms & Conditions")}
                        </Link>{t("and")}<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf'>
                            {t("Data Privacy Rights.")}
                        </Link> {t("Need Help?")}<Link target='_blank'
                            url={`https://admin.shopify.com/apps${process.env.REACT_APP_SHOPIFY_APP_BASE}/panel/user/support`} >
                            {t("Get Support")}
                        </Link>{t("or")}<Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales" >
                            {t("Book a Call")}
                        </Link>
                    </InlineStack>
                </FooterHelp>
            </Page>
        );
    }
}

const CustomBadgeWithCount=(props:any)=>{
    const {count} = props
    return (
        <div className='custom-count-badge-wrapper'>
            <div className='custom-count-badge-container'></div>
            <sup className='custom-badge-count'>{count}</sup>
        </div>
    )
}

export default DI(ViewOrder);